
import React from "react";
import fields from "../../json/LeaveApplicationFields.json";
import FormInput from "Common/Custom/FormInput";
import FormDatePicker from "Common/Custom/ReactFlatpickr";
import FormSelect from "Common/Custom/FormSelect";
import FormTextarea from "Common/Custom/FormTextarea";
import FormInputFile from "Common/Custom/FormInputFile";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";

const AddLeaveApplicationForm = ({
    values,
    errors,
    handleChange,
    handleFileChange,
    handleSubmit,
    loading,
    options,
    leaveStats,
    imagePreview
}) => {
    const { formdata } = fields;

    const renderField = (field) => {
        if (field.type === "date") {
            return (
                <FormDatePicker
                    key={field.name}
                    field={field}
                    value={values[field.name]}
                    handleChange={handleChange}
                    error={errors[field.name]}
                    mode="date"
                    required={field.required}
                />
            );
        }

        if (field.type === "select") {
            const selectOptions = options[field.name.replace("_id", "")] || options[field.name.replace("approved_by", "supervisor")] || [];
            const formattedOptions = selectOptions.map(opt => ({
                value: opt.id,
                label: opt.name
            }));

            return (
                <FormSelect
                    key={field.name}
                    field={field}
                    value={values[field.name]}
                    handleChange={handleChange}
                    options={formattedOptions}
                    error={errors[field.name]}
                />
            );
        }

        if (field.type === "textarea") {
            return (
                <FormTextarea
                    key={field.name}
                    field={field}
                    value={values[field.name]}
                    handleChange={handleChange}
                    error={errors[field.name]}
                />
            );
        }

        if (field.type === "switch") {
            return (
                <Switch
                    values={values[field.name] }
                    handleChange={handleChange}
                    error={errors[field.name]}
                    field={field}
                    ValueOne="1"
                    ValueTwo="0"
                    LabelOne="Full Day"
                    LabelTwo="Half Day"
                />
            );
        }

        if (field.type === "file") {
            return (
                <FormInputFile
                    key={field.name}
                    field={field}
                    handleChange={handleFileChange}
                    error={errors[field.name]}
                    imagePreview={imagePreview}
                />
            );
        }

        return (
            <FormInput
                key={field.name}
                field={field}
                value={values[field.name]}
                handleChange={handleChange}
                error={errors[field.name]}
            />
        );
    }

    return (
        <PageBody onSubmit={handleSubmit} headerchildren={
            <HeadingOne>Leave Application</HeadingOne>
        }>
            <div className="col-12">
                <div className="card border-0" style={{ background: "linear-gradient(135deg, rgba(var(--primary-rgb), 0.1) 0%, rgba(var(--primary-rgb), 0.1) 100%)", borderRadius: "12px", borderLeft: "4px solid var(--primary-rgb)" }}>
                    <div className="card-body p-3">
                        <div className="d-flex align-items-center justify-content-center justify-content-md-between flex-wrap gap-3 text-center text-md-start">
                            <div className="">
                                <h6 className="mb-0 text-dark fw-bold">Leave Statistics</h6>
                                <p className="text-muted small mb-0">Current status for selected leave type</p>
                            </div>
                            <div className="d-flex flex-wrap justify-content-center gap-2 gap-sm-4">
                                <div className="text-center">
                                    <span className="text-muted small d-block mb-1">Enjoyed</span>
                                    <span className="badge bg-danger-subtle text-danger px-3 py-2 rounded-pill fw-bold fs-6">
                                        {leaveStats?.enjoyed_days || 0} Days
                                    </span>
                                </div>
                                <div className="text-center">
                                    <span className="text-muted small d-block mb-1">Total Leave</span>
                                    <span className="badge bg-success-subtle text-success px-3 py-2 rounded-pill fw-bold fs-6">
                                        {leaveStats?.total_days || 0} Days
                                    </span>
                                </div>
                                <div className="text-center">
                                    <span className="text-muted small d-block mb-1">Available</span>
                                    <span className="badge bg-primary-subtle text-primary px-3 py-2 rounded-pill fw-bold fs-6">
                                        {Math.max((leaveStats?.total_days || 0) - (leaveStats?.enjoyed_days || 0), 0)} Days
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {formdata.map((field) => renderField(field))}

            <div className="col-12 mt-3 d-flex justify-content-end gap-2">
                <FormSubmitButton
                    label="Save"
                    loading={loading}
                    colSize="col-auto"
                />
            </div>
        </PageBody>
    );
};

export default AddLeaveApplicationForm;
